import { Response } from '../api/typegen/client/get';
import { routes } from '../routes';
import { useCallback, useEffect, useState } from 'react';
import { useErrorManager } from 'InternalLibrary';
import axiosInstance from '../utils/axiosInstance';
import useClient from './useClient';

export const PAYLAND_SEARCHPARAM_CONTINUE = 'paylandContinue';

interface Props {
  continueScreen?: (typeof routes)[keyof typeof routes];
}

export const usePayment = ({ continueScreen }: Props = {}) => {
  const ROUTES_PAYLAND_ENABLED = [
    routes.FirstLoan_OnlineBank_Approved,
    routes.FirstLoan_OnlineBank_Pending,
  ];

  const [autoRepayEnabled, setAutoRepayEnabled] = useState<boolean | undefined>(
    undefined,
  );
  const { client } = useClient();
  const { setError } = useErrorManager();

  const generatePaylandUrl = useCallback(
    async (client: Response | undefined | null) => {
      try {
        const url_ko = `${window.location.origin}${routes.payment_failed}?${PAYLAND_SEARCHPARAM_CONTINUE}=${continueScreen}`;
        const url_ok = `${window.location.origin}${routes.payment_success}?${PAYLAND_SEARCHPARAM_CONTINUE}=${continueScreen}`;

        const response = await axiosInstance.post(
          '/cardpayments/store-credit-card',
          {
            applicationName: 'Vivus.es',
            clientNumber: client?.number,
            failureUrl: url_ko,
            successUrl: url_ok,
            username: client?.fullName,
          },
          {
            headers: {
              Accept: 'application/vnd.cardpayments.v1+json',
              'Content-Type': 'application/vnd.cardpayments.v1+json',
            },
          },
        );
        return response?.data?.payformUrl;
      } catch (e) {
        setError(e);
        return;
      }
    },
    [continueScreen, setError],
  );

  const activateAutoRepay = useCallback(async () => {
    const source = await generatePaylandUrl(client);

    if (source) {
      window.location.replace(source);
    }
  }, [client, generatePaylandUrl]);

  useEffect(() => {
    const checkUserPreferences = async () => {
      if (!sessionStorage.getItem('token')) return;

      try {
        const response = await axiosInstance.get('/client/payment-preferences');
        const { autoRepay } = response.data || {};
        setAutoRepayEnabled(autoRepay);
      } catch (e) {
        setError(e);
      }
    };
    const isPaylandRoute = ROUTES_PAYLAND_ENABLED.includes(
      window.location.pathname,
    );
    if (isPaylandRoute || autoRepayEnabled === undefined)
      checkUserPreferences();
  }, [autoRepayEnabled, setError]);

  return {
    activateAutoRepay,
    autoRepayEnabled,
    showAutoPaymentSection: autoRepayEnabled !== true,
  };
};
